import type { ImportedApplicabilityItem } from '../types/part/partTypes'

/**
 * Разбирает строку применимостей из автоимпорта (part.extraData.AvitoCompatibleCars).
 *
 * Пример входного значения:
 * "Mercedes-Benz|GLE-класс Coupe|C292 (2015—2019)||| Mercedes-Benz|GLS-класс|X166 (2015—2019)|||"
 *
 * Применимости разделены "|||", поля внутри применимости — "|".
 * Возвращает список читаемых заголовков, например:
 * ["Mercedes-Benz GLE-класс Coupe C292 (2015—2019)", "Mercedes-Benz GLS-класс X166 (2015—2019)"]
 */
export const parseImportedApplicabilityItems = (value?: string): ImportedApplicabilityItem[] => {
    if (!value) return []

    return value
        .split('|||')
        .map(raw => raw.trim())
        .filter(Boolean)
        .map(raw => ({
            raw,
            title: raw
                .split('|')
                .map(part => part.trim())
                .filter(Boolean)
                .join(' '),
        }))
        .filter(item => item.title.trim())
}

export const parseImportedApplicabilities = (value?: string): string[] =>
    parseImportedApplicabilityItems(value).map(item => item.title)

export const stringifyImportedApplicabilities = (items: ImportedApplicabilityItem[]): string =>
    items
        .map(item => item.raw.trim())
        .filter(Boolean)
        .join('|||')
